export default {
  USER_IS_NOT_EXIST_IN_THE_EMPLOYEES: 'Nhân viên không tồn tại!',
  USER_ERROR_EMAIL_HAS_BEEN_REGISTERED: 'Email đã được đăng ký!',
  USER_IS_NOT_CONTANT_THE_PASSWORD: 'Mật khẩu không được chứa tên người dùng',
};
